// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cryptoTotal_wrapper__3vpN0","imgWrapper":"cryptoTotal_imgWrapper__2fI79","imgWraaper":"cryptoTotal_imgWraaper__3TDQm","darklogo":"cryptoTotal_darklogo__2S17W"};